//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import React from 'react';

interface IOwnProps {
  label: string;
}

export const CustomLabel: React.SFC<IOwnProps> = (props) => {
  const { label, children } = props;
  return (
        <label className='cu-d-block cu-my-3'>
            <p className='cu-mb-2'>{ label }</p>
            { children }
        </label>
  );
};
